import { request, METHOD, removeAuthorization } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;
export function getDeliveryArea() {
  return request("".concat(BASE_URL) + "/deliveryArea/list", METHOD.GET);
}
export function getDeliveryEnableArea() {
  return request("".concat(BASE_URL) + "/deliveryArea/enableList", METHOD.GET);
}
export function getCarriage(data) {
  return request("".concat(BASE_URL) + "/carriage", METHOD.GET, data);
}
export function putCarriage(data) {
  return request("".concat(BASE_URL) + "/carriage", METHOD.PUT, data);
}
export function putCarriageStatus(data) {
  return request("".concat(BASE_URL) + "/carriage/status", METHOD.PUT, data);
}